import {SET_ERROR} from "../actions/actionTypes";

const initState = {
  error: []
};

export function errorReducer(state = initState, action) {
  const {error} = action;

  if (error && error.length > 0) {
    return {
      error
    }
  } else if (action.type === SET_ERROR) {
    return initState;
  } else {
    return state;
  }
}